import api from "./api";

export default class SuportSolicitationsAPI {
  static getSuporteList = async (
    Page: number,
    RecordsPerPage: number,
    dataInicio: string,
    dataFim: string,
    idServicoStatus: number,
    idCliente: number,
    idTipoServico: number
  ) => {
    const response = await api.get(
      `/ServicoSolicitacoes?Page=${Page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}
      &idServicoStatus=${idServicoStatus}&idCliente=${idCliente}&idTipoServico=${idTipoServico}`
    );
    return response;
  };

  static getSuportSolicitationPerId = async (id: number) => {
    const response = await api.get(`/ServicoSolicitacoes/${id}`);
    return response.data;
  };

  static getSuporteAndamento = async (id: number) => {
    const response = await api.get(`/ServicoSolicitacoes/${id}/andamento`);
    return response.data;
  };

  static postSuporteAndamento = async (id: number, obj: any) => {
    const response = await api.post(
      `/ServicoSolicitacoes/${id}/andamento`,
      obj
    );
    return response.data;
  };

  static postSuporte = async (obj: any) => {
    const response = await api.post(
      `/ServicoSolicitacoes`,
      obj
    );
    return response.data;
  };
}
